import React from 'react';
import { Bell, ChevronRight, Clock, ListChecks, ScanLine, Upload } from 'lucide-react';
import { DMPLogo } from '../brand/DMPLogo';
import { StatusBadge } from '../StatusBadge';
import { officerActivities, officerProfile } from '../../data/officer';
import type { OfficerScreen } from '../../types/officer';
export function OfficerHome({
  go
}: {
  go: (s: OfficerScreen) => void;
}) {
  const actions: {
    label: string;
    icon: typeof ScanLine;
    to: OfficerScreen;
    color: string;
    badge?: string;
  }[] = [{
    label: 'নোটিশ স্ক্যান করুন',
    icon: ScanLine,
    to: 'camera',
    color: '#003B71'
  }, {
    label: 'নোটিশ আপলোড করুন',
    icon: Upload,
    to: 'preview',
    color: '#006A4E'
  }, {
    label: 'অপেক্ষমাণ নোটিশ',
    icon: Clock,
    to: 'activities',
    color: '#E69A20',
    badge: '৪'
  }, {
    label: 'আমার কার্যক্রম',
    icon: ListChecks,
    to: 'activities',
    color: '#1769AA'
  }];
  return <div className="flex-1 overflow-y-auto bg-[#F4F7FB]" data-id="element-500" data-mp="22tmbshzfxeva">
      <div className="bg-[#003B71] px-4 pb-16 pt-4 text-white" data-id="element-501" data-mp="1xw2yplehb84x">
        <div className="flex items-center gap-2" data-id="element-502" data-mp="2n71v2gy0w9e3">
          <DMPLogo size={36} data-id="element-503" data-mp="2n7lb1s444nph" />
          <div className="flex-1 text-[13px] leading-tight" data-id="element-504" data-mp="2s5wk40ml2u6n"><div className="font-semibold" data-id="element-505" data-mp="2s4lia6cp7wi6">ঢাকা মেট্রোপলিটন পুলিশ</div><div className="text-white/70" data-id="element-506" data-mp="2e6dp89is9fca">প্রসিকিউশন নোটিশ ব্যবস্থাপনা</div></div>
          <button className="relative rounded-full p-2 hover:bg-white/10" aria-label="নোটিফিকেশন" data-id="element-507" data-mp="2e8gc4kon2scs"><Bell className="h-5 w-5" data-id="element-508" data-mp="2j7b5uho5a1bo" /><span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-[#E69A20]" data-id="element-509" data-mp="24gak5aye0axl" /></button>
        </div>
      </div>
      <div className="-mt-12 px-4" data-id="element-510" data-mp="297ahghbf4v0m">
        <div className="rounded-2xl bg-white p-4 shadow-sm" data-id="element-511" data-mp="298bu2q831pkg">
          <div className="flex items-center gap-3" data-id="element-512" data-mp="1vgf7f1p6o7vg">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#006A4E] text-lg font-bold text-white" data-id="element-513" data-mp="1vdjbfiwwbt9n">রা</div>
            <div className="min-w-0 flex-1" data-id="element-514" data-mp="1lgwq6t0nr073">
              <div className="truncate font-semibold" data-id="element-515" data-mp="1li83bjfztkav">{officerProfile.name}</div>
              <div className="truncate text-xs text-slate-500" data-id="element-516" data-mp="1qf7zn2n1j8os">{officerProfile.unit}</div>
            </div>
          </div>
          <div className="mt-4 grid grid-cols-3 divide-x divide-border rounded-lg bg-[#F4F7FB] py-2 text-center" data-id="element-517" data-mp="3s701lqkjam67">
            {[['আজ', '১২'], ['অপেক্ষমাণ', '৪'], ['এই মাসে', '২৪৮']].map(([l, v]) => <div key={l} data-id="element-518" data-mp="3jbajpriao9xk"><div className="text-lg font-bold text-[#003B71]" data-id="element-519" data-mp="3jb0qzw5v7oo6">{v}</div><div className="text-[11px] text-slate-500" data-id="element-520" data-mp="3eflfvbz8s6vg">{l}</div></div>)}
          </div>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-3" data-id="element-521" data-mp="eydr9iw9vmru">
          {actions.map(a => {
          const Icon = a.icon;
          return <button key={a.label} onClick={() => go(a.to)} className="relative flex flex-col items-start gap-3 rounded-2xl bg-white p-4 text-left shadow-sm active:scale-[0.98]" data-id="element-522" data-mp="5y8jv8r2wodo">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl text-white" style={{
              backgroundColor: a.color
            }} data-id="element-523" data-mp="11ryunf6eq4t"><Icon className="h-5 w-5" data-id="element-524" data-mp="2lpwhl6dx2kxj" /></span>
                <span className="text-[14px] font-semibold leading-snug" data-id="element-525" data-mp="2lobjj6se8jux">{a.label}</span>
                {a.badge && <span className="absolute right-3 top-3 rounded-full bg-[#E69A20] px-2 py-0.5 text-[11px] font-bold text-white" data-id="element-526" data-mp="2bnj0pmjki7al">{a.badge}</span>}
              </button>;
        })}
        </div>

        <div className="mb-4 mt-5" data-id="element-527" data-mp="2likl652wel6u">
          <div className="mb-2 flex items-center justify-between" data-id="element-528" data-mp="2qac7u4ixo6rp"><h2 className="text-sm font-semibold" data-id="element-529" data-mp="2qbwznmdv5blv">সাম্প্রতিক নোটিশ</h2><button onClick={() => go('activities')} className="text-xs text-[#1769AA]" data-id="element-530" data-mp="2ucz2ed6zo5sl">সব দেখুন</button></div>
          <div className="divide-y divide-border rounded-2xl bg-white shadow-sm" data-id="element-531" data-mp="2za90eh8g1ps1">
            {officerActivities.slice(0, 3).map(a => <button key={a.caseNo} onClick={() => go('details')} className="flex w-full items-center gap-2 px-4 py-3 text-left" data-id="element-532" data-mp="348agctakp8za">
                <div className="min-w-0 flex-1" data-id="element-533" data-mp="19wlzumop0ycs"><div className="truncate font-mono text-[12px] text-[#003B71]" data-id="element-534" data-mp="19xdthryqcm0f">{a.caseNo}</div><div className="text-[12px] text-slate-500" data-id="element-535" data-mp="1euxcf56dhmyp">{a.vehicle}</div></div>
                <StatusBadge label={a.status} data-id="element-536" data-mp="35cal0j4csyhc" />
                <ChevronRight className="h-4 w-4 text-slate-300" data-id="element-537" data-mp="35azi0liqfura" />
              </button>)}
          </div>
        </div>
      </div>
    </div>;
}